import { actionTypes } from "./constants";

export const initialState = {
    data: null,   
    previousRequestSource: null,
    fetching: false
}

export const actionBarReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_ACTION_BAR_DATA:
            return {
                ...state,
                data: action.payload
            }
        case actionTypes.SET_ACTION_BAR_CANCEL_TOKEN:
            return {
                ...state,
                previousRequestSource: action.previousRequestSource
            }
        case actionTypes.IS_ACTION_BAR_FETCHING:
            return {
                ...state,
                fetching: action.fetching
            }
        default:
            return state;
    }
} 